import React from 'react';

interface Props {
	data: boolean | null;
}
export const GeneralTCText: React.FC<Props> = props => {
	const { data } = props;
	const getContent = () => {
		return (
			<ul>
				<li>
					Price includes Bank Holiday, out of hours and fuel surcharges, gratuities and
					admin fees.
				</li>
				<li>
					{data
						? 'Price excludes tolls, parking, waiting time. Tax is included.'
						: 'Price excludes tolls, parking, waiting time and tax.'}
				</li>
				<li>
					If your journey type is ‘As Directed’ or quoting per hour please note the total
					shown is the amount you will be charged per hour and the time is calculated from
					when the driver leaves the base and will end once the driver is back at the
					base.
				</li>
			</ul>
		);
	};
	return <>{getContent()}</>;
};
